import { axiosCompanyPortalInstance } from "./";

const COMPANY_USERS_PATH = "/company/company_users";

/** GET /company_portal/v1/company/company_users — list/search employees.
 * Pagination is returned via response headers (Current-Page, Page-Items,
 * Total-Count, Total-Pages). `name` does a case-insensitive partial match. */
const getCompanyUsers = (params = {}, config = {}) =>
  axiosCompanyPortalInstance.get(COMPANY_USERS_PATH, { ...config, params });

/** GET /company_portal/v1/company/company_users/:id — show a single employee. */
const getCompanyUser = (id) =>
  axiosCompanyPortalInstance.get(`${COMPANY_USERS_PATH}/${id}`);

/** POST /company_portal/v1/company/company_users — create & invite an employee.
 * Server forces company_id / profile_status / tmp password and emails the
 * invitation. Do not send password or profile_status. */
const createCompanyUser = (data) =>
  axiosCompanyPortalInstance.post(COMPANY_USERS_PATH, data);

/** PATCH /company_portal/v1/company/company_users/:id — edit profile data.
 * email / password / profile_status are not updatable. Changing
 * company_role_id logs the employee out (clears their device tokens). */
const updateCompanyUser = ({ id, data }) =>
  axiosCompanyPortalInstance.patch(`${COMPANY_USERS_PATH}/${id}`, data);

/** DELETE /company_portal/v1/company/company_users/:id — remove an employee.
 * 404 if not in the caller's company; 403 without Employees.can_delete. */
const deleteCompanyUser = (id) =>
  axiosCompanyPortalInstance.delete(`${COMPANY_USERS_PATH}/${id}`);

export {
  getCompanyUsers,
  getCompanyUser,
  createCompanyUser,
  updateCompanyUser,
  deleteCompanyUser,
};
